import React, { useEffect, useMemo, useState } from 'react';
import { Link, Head, useForm } from '@inertiajs/inertia-react';
import logo from '../../images/logo.png';
import Input from '@/Components/Input';
import Label from '@/Components/Label';
import Button from '@/Components/Button';
import Checkbox from '@/Components/Checkbox';
import OrderStatus, { formatter } from '@/Components/OrderStatus';
import phone from 'phone';
import Error from '../Components/Error';
//import { useMercadopago } from 'react-sdk-mercadopago';
import Checkout from '@/Components/Checkout';
import axios from 'axios';
import ApplicationLogo from '@/Components/ApplicationLogo';


// // Import Swiper React components
// import { Swiper, SwiperSlide } from 'swiper/react';

// // Import Swiper styles
// import 'swiper/css';
// import 'swiper/css/navigation';
// import { Navigation } from 'swiper';
import numberFormat from '@/helpers/numberFormat';
import rut from '@/helpers/rut';
import { userIsValid, usersAreValid } from '@/helpers/user';
import _ from 'lodash';
import classNames from 'classnames';
import Clients from '@/Components/Clients';
import Timer from '@/Components/Timer';
import { DateTime } from 'luxon';
import Cookies from 'js-cookie';
import { Inertia } from '@inertiajs/inertia';
import CouponForm from '@/Components/CreateOrder/CouponForm';
import { showJSONData } from '@/helpers/example';
import { useUsersRegistrationContext } from '@/context/UsersRegistration';

export default function CreateOrder({
    uuid,
    office,
    scheduleType,
    store,
    terms,
    price,
    quantity,
    date,
    time,
    rawDate,
    schedule,
    consent,
    flash,
    MPPublicKey,
     ...props}) {

    const {responsibleUser, usersRegistration, responsibleForAssistants} = useUsersRegistrationContext();

    const { data, setData, get, processing, errors, post } = useForm({
        'firstName': responsibleUser?.name,
        'secondName': responsibleUser?.lastname,
        'email': responsibleUser?.email,
        'telephone': responsibleUser?.telephone,
        'socks': 0,
        'terms': '',
        'consent': '',
        schedule: schedule,
        quantity,
        'coupon_code': flash?.coupon_code || '',
        'coupon_percent': flash?.coupon_percent || null,
        'coupon_id': flash?.coupon_id || null,
        users: usersAreValid(usersRegistration, quantity, responsibleForAssistants) ? (responsibleForAssistants ? [] : usersRegistration) : [],
        'rut': responsibleUser?.rut,
        date,
        order_created_at: flash?.order_created_at || Cookies.get('order_created_at'),
        order_id: flash?.order_id,
        uuid,
        is_responsible_for_assistants: responsibleForAssistants
    });


    const [productsDetails, setProductsDetails] = useState(props.products?.map(product => ({
        product_id: product.id,
        quantity: 0,
        totalPrice: 0,
        name: product.name,
        price: product.price,
        errors: [],
        stock: product.stock
    })) || []);

    const [isProcessingButtonPayment, setIsProcessingButtonPayment] = useState(false);
    const [couponErrors, setCouponErrors] = useState([]);
    const [axiosErrors, setAxiosErrors] = useState({});

    const [orderCheckoutId, setOrderCheckoutId] = useState(flash?.order_id);

    const removeError = (error) => {
        try {
            const filteredAxiosErrors = _.omit(axiosErrors, error);
            setAxiosErrors(filteredAxiosErrors);
        } catch (error) {}
    }

    useEffect(() => {
        if (scheduleType.type !== 'skating_class' && scheduleType.type !== 'skating_class_monthly') {
            if (!usersAreValid(usersRegistration, quantity, responsibleForAssistants)) return get(route('schedule.users-registration', {office: office.slug, scheduleType: scheduleType}));
        }
        if (!userIsValid(responsibleUser)) return get(route('schedule.users-registration', {office: office.slug, scheduleType: scheduleType}))
    }, [responsibleUser, usersRegistration])

    const onHandleChange = (event, value = undefined) => {
        removeError(event.target.name);
        setData(event.target.name, event.target.type === 'checkbox' ? (value !== undefined ? value : event.target.checked) : (value !== undefined ? value : event.target.value));
    };

    const sanitizePhone = event => {
        const value = event.target.value;
        const formatedNumber = phone(
            value.length === 8 ? '9' + value : value,
            { country: 'CL' }
        );
        if (formatedNumber.isValid) setData('telephone', formatedNumber.phoneNumber);
    }

    const [preference, setPreference] = useState(null);
    const [ticketDeadline, setTicketDeadline] = useState(null);

    const submit = (e) => {
        e.preventDefault();
        setIsProcessingButtonPayment(true);

        setTicketDeadline(DateTime.now().plus({ minutes: 10 }));

        try {
            Array.from(document.querySelectorAll('.mp-mercadopago-checkout-wrapper')).forEach(element => element.remove());
        } catch (error) {}
        setPreference(null);

        axios.post('/api/mercadopago-payment/' + office.slug, {...data, productsDetails, office: office.slug, scheduleType:scheduleType.id })
        .then(response => {
            console.log({response})
            window.localStorage.setItem('response', JSON.stringify(response));
            if(response.data.status === 'success'){
                if (response.data?.uuid) {
                    Inertia.visit(route('order.show', {uuid: response.data?.uuid}, { replace: true }));
                    return;
                }

                setProductsDetails(response.data.product_details.map((product_detail) => ({
                    ...productsDetails.find(({ product_id }) => product_id === product_detail.product_id),
                    stock: product_detail.stock
                })));

                setPreference({id: response.data.preferenceId, init_point: response.data.preferenceInitPoint});
                setOrderCheckoutId(response.data.order_id)
                Cookies.set('order_created_at', response.data.order_created_at);
            }
            if(response.data.status === 'noquota'){
                alert('Este ticket ya no esta disponible.')
            }
        }).catch(error => {
            console.log('ERROR PETICION ORDER', {error})
            if (error.response.data.status === 'branch-office.not-active') {
                window.location.href = route('redirect', { url: route('branch-office.selector'), status: 'branch-office.not-active' })
            }
            if (error.response.data.status === 'products_exceed_max') {
                error.response.data.products.forEach(({ product_id, product_name, error }) => {
                    const productDetail = productsDetails.find(detail => detail.product_id === product_id);
                    const filteredProductsDetails = productsDetails.filter(detail => detail.product_id !== product_id);
                    setProductsDetails([...filteredProductsDetails, {
                        ...productDetail,
                        errors: [
                            {
                                'message': error,
                                'status': 'product_exceed_max'
                            },
                        ],
                    }]);
                })
            }
            if (error.response.data?.errors) {
                setAxiosErrors(error.response.data.errors)
            }

            setIsProcessingButtonPayment(false);
        })
    }

    const handleChangeProductQuantity = ({ id, price, name, stock }, operation, options) => {
        if (stock <= 0) return;

        const product = productsDetails.find(productDetail => productDetail.product_id === id);
        const filteredProductsDetails = productsDetails.filter(filteredProductDetail => filteredProductDetail.product_id !== product.product_id);

        const getQuantity = () => {
            if (!options) return operation(product.quantity);

            const operatedQuantity = operation(product.quantity);

            const hasMin = options?.min === 0 ? true : Boolean(options?.min);
            const hasMax = options?.max === 0 ? true : Boolean(options?.max);

            if (hasMin && hasMax) {
                if (operatedQuantity < options.min) {
                    return options.min;
                }

                if (operatedQuantity > options.max) {
                    return options.max;
                }
            } else if (hasMin) {
                if (operatedQuantity < options.min) {
                    return options.min;
                }
            } else if (hasMax) {
                if (operatedQuantity >= options.max) {
                    return options.max;
                }
            }

            return operatedQuantity;
        }

        const quantity = getQuantity();

        setProductsDetails([
            ...filteredProductsDetails,
            {
                product_id: id,
                quantity,
                totalPrice: price * quantity,
                name,
                price,
                errors: []
            }
        ].sort((a, b) => a.product_id - b.product_id))
    }

    const onTimeout = () => {
        Cookies.remove('order_created_at');
        Cookies.remove('order_checkout_id');
        Cookies.remove('order_checkout_clients');
        Inertia.visit(route('order.ticket-expired', {office, scheduleType}), { replace: true });
    }

    return (
        <>
            <Head title={`Compra de tickets - ${store}`} />
            {/* <pre><code>{JSON.stringify(data, null, 4)}</code></pre> */}

            <div className="relative flex items-top justify-center min-h-screen bg-gray-100 sm:items-center sm:pt-0">

                <div className="max-w-7xl mx-2 sm:mx-auto sm:px-6 lg:px-8 py-4">

                    <div className="flex justify-center pt-8 sm:pt-0 mb-4">
                        {/* <img src={logo} className="h-16 w-auto sm:h-20" /> */}
                        <ApplicationLogo store={store} />
                    </div>

                    <form onSubmit={submit} autoComplete='on'>

                        <div className="w-full sm:max-w-md px-6 py-4 bg-white shadow-md overflow-hidden sm:rounded-lg">

                            {/* <h1 className='mb-4 text-gray-900 text-lg font-bold'>Datos de contacto del responsable</h1> */}

                            <div className="grid gap-2">
                                {/* {!uuid && orderCheckoutId && (flash?.order_created_at || data.order_created_at || ticketDeadline) && (
                                    <Timer
                                        deadline={flash?.order_created_at ? DateTime.fromFormat(flash?.order_created_at, 'dd-MM-yyyy HH:mm:ss').plus({ minutes: 10 }) : (data.order_created_at ? DateTime.fromISO(data.order_created_at).plus({ minutes: 10 }) : ticketDeadline)}
                                        format="mm:ss"
                                        onFinish={onTimeout}
                                        messageOnFinish={<></>}
                                    />
                                )} */}

                                {/* {!uuid && orderCheckoutId && (flash?.order_created_at || data.order_created_at || ticketDeadline) && ( */}
                                <Timer
                                    deadline={DateTime.now().plus({ minutes: 30 })}
                                    format="mm:ss"
                                    onFinish={onTimeout}
                                    messageOnFinish={<></>}
                                    hide
                                />
                                {/* )} */}

                                {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
                                    <div>
                                        <Label forInput="firstName" value="Nombre" />
                                        <Input
                                            type="text"
                                            min="0"
                                            name="firstName"
                                            value={data.firstName}
                                            className="mt-1 block w-full"
                                            isFocused={true}
                                            required={true}
                                            handleChange={onHandleChange}
                                            autoComplete='given-name'
                                        />
                                        <Error bind={errors.firstName || axiosErrors?.firstName} />
                                    </div>

                                    <div>
                                        <Label forInput="secondName" value="Apellido" />
                                        <Input
                                            type="text"
                                            min="0"
                                            name="secondName"
                                            value={data.secondName}
                                            className="mt-1 block w-full"
                                            required={true}
                                            handleChange={onHandleChange}
                                            autoComplete='family-name'
                                        />
                                        <Error bind={errors.secondName} />
                                    </div>

                                    <div>
                                        <Label forInput="rut" value="R.U.N" />
                                        <Input
                                            type="text"
                                            name="rut"
                                            value={data.rut}
                                            className="mt-1 block w-full"
                                            required={true}
                                            handleChange={(event) => onHandleChange(event, rut.format(event.target.value) === '-' ? '' : rut.format(event.target.value))}
                                            autoComplete='rut'
                                        />
                                        <Error bind={errors.rut || axiosErrors?.rut} />
                                    </div>
                                </div> */}

                                {/* <div className="grid grid-cols-1 md:grid-cols-12 gap-2">
                                    <div className="md:col-span-5">
                                        <Label forInput="telephone" value="Teléfono" />
                                        <Input
                                            type="tel"
                                            name="telephone"
                                            value={data.telephone}
                                            className="mt-1 block w-full"
                                            required={true}
                                            handleChange={onHandleChange}
                                            handleBlur={sanitizePhone}
                                            autoComplete='tel'
                                        />
                                        <Error bind={errors.telephone || axiosErrors?.telephone} />
                                    </div>

                                    <div className="md:col-span-7">
                                        <Label forInput="email" value="E-mail" />
                                        <Input
                                            type="email"
                                            name="email"
                                            value={data.email}
                                            className="mt-1 block w-full"
                                            required={true}
                                            handleChange={onHandleChange}
                                            autoComplete='email'
                                        />
                                        <Error bind={errors.email || axiosErrors?.email} />
                                    </div>
                                </div> */}
                            </div>

                            <div>
                                <h2 className='mb-3 text-gray-900 text-lg font-bold'>Estás a un paso de completar tu {Boolean(uuid) ? 'cobro' : 'compra'}</h2>
                                {((scheduleType.type !== 'skating_class' && scheduleType.type !== 'skating_class_monthly') && !data.uuid && Boolean(props?.products.length)) && (
                                        <div className='grid grid-cols-1 gap-3 mt-4'>
                                            {/* <Swiper
                                                modules={[Navigation]}
                                                navigation
                                                spaceBetween={20}
                                                slidesPerView={2}
                                            >
                                                {props.products.map((product, index) => {
                                                    const detail = productsDetails.find((productDetail) => productDetail.product_id === product.id);

                                                    const QuantityButton = ({ className, ...props }) => (
                                                        <button type="button" className={classNames("flex justify-center items-center py-1", className)} {...props} />
                                                    )

                                                    const MinusButton = () => (
                                                        <QuantityButton className="bg-gray-700 rounded-tl-xl" onClick={() => handleChangeProductQuantity(product, (quantity) => quantity - 1, { min: 0 })}>
                                                            <svg className="h-6" style={{ fill: '#ffffff' }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"/></svg>
                                                        </QuantityButton>
                                                    )

                                                    const PlusButton = () => (
                                                        <QuantityButton className="bg-black rounded-tr-xl" onClick={() => handleChangeProductQuantity(product, (quantity) => quantity + 1, { max: Boolean(product.max_by_tickets_number) ? data.quantity : (product.max ? product.max : null) })}>
                                                            <svg className="h-6" style={{ fill: '#ffffff' }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"/></svg>
                                                        </QuantityButton>
                                                    )

                                                    return (
                                                        <SwiperSlide key={`product-item-${product.id}-${index}`}>
                                                            <div
                                                                className="bg-white border rounded-xl"
                                                                style={{
                                                                    borderColor: detail.errors?.length > 0 ? 'red' : undefined,
                                                                    borderWidth: detail.errors?.length > 0 ? '2px' : undefined,
                                                                }}
                                                            >
                                                                <div className="grid grid-cols-2 h-6">
                                                                    <MinusButton />
                                                                    <PlusButton />
                                                                </div>
                                                                <div className="py-4">
                                                                    <h4 className="text-center font-bold">
                                                                        {detail.quantity}
                                                                    </h4>
                                                                    <h4 className="text-center font-bold">
                                                                        {product.name}
                                                                    </h4>
                                                                    <h4 className="text-center">
                                                                        ${numberFormat(product.price, 0, '', '.')}
                                                                    </h4>
                                                                </div>
                                                            </div>
                                                            <div className="flex flex-col gap-2">
                                                                {detail.errors?.map(({ message, status }, index) => (
                                                                    <div className="m-0 p-0 text-sm text-center" style={{ color: 'red' }} key={`product-${product.id}-error-${status}-${index}`}>
                                                                        {message}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </SwiperSlide>
                                                    )
                                                })}
                                            </Swiper> */}

                                                {props.products.map((product, index) => {
                                                    const detail = productsDetails.find((productDetail) => productDetail.product_id === product.id);

                                                    const QuantityButton = ({ className, ...props }) => (
                                                        <button type="button" className={classNames("inline-flex justify-center items-center py-1", className, {
                                                            "bg-primary": product.stock > 0 && store === 'cerogrado',
                                                            "bg-tp-primary": product.stock > 0 && store === 'trampolinepark',
                                                            "bg-gray-400 pointer-events-none": product.stock <= 0
                                                        })} {...props} />
                                                    )

                                                    const MinusButton = () => (
                                                        <QuantityButton 
                                                            className="sm:rounded-l-md" 
                                                            onClick={() => handleChangeProductQuantity(product, (quantity) => quantity - 1, { min: 0 })}
                                                        >
                                                            <svg className="h-4" style={{ fill: product.stock > 0 ? (store === 'cerogrado' ? '#ffffff' : '#000000') : '#ffffff' }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"/></svg>
                                                        </QuantityButton>
                                                    )

                                                    const PlusButton = () => (
                                                        <QuantityButton 
                                                            className="sm:rounded-none" 
                                                            onClick={() => {
                                                                handleChangeProductQuantity(product, (quantity) => quantity + 1, {
                                                                    max: (() => {
                                                                        if (product.max_by_tickets_number) {
                                                                            if (product.stock >= data.quantity) {
                                                                                return data.quantity;
                                                                            }
                                                                        } else {
                                                                            if (product.max) {
                                                                                if (product.stock >= product.max) {
                                                                                    return product.max;
                                                                                }
                                                                            }
                                                                        }
                                                                        return product.stock;
                                                                    })()
                                                                })
                                                            }}
                                                        >
                                                            <svg className="h-4" style={{ fill: product.stock > 0 ? (store === 'cerogrado' ? '#ffffff' : '#000000') : '#ffffff' }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"/></svg>
                                                        </QuantityButton>
                                                    )

                                                    return (
                                                        <div key={`product-item-${product.id}-${index}`}>
                                                            <div
                                                                className={classNames("flex flex-col sm:flex-row items-start sm:items-center justify-between rounded-md border overflow-hidden", {
                                                                    "bg-accent border-primary": product.stock > 0 && store === 'cerogrado',
                                                                    "bg-tp-accent border-tp-primary": product.stock > 0 && store === 'trampolinepark',
                                                                    "bg-gray-500 border-gray-400": product.stock <= 0
                                                                })}
                                                                style={{
                                                                    borderColor: detail.errors?.length > 0 ? 'red' : undefined,
                                                                    borderWidth: detail.errors?.length > 0 ? '2px' : undefined,
                                                                }}
                                                            >
                                                                <div className="flex items-center w-full">
                                                                    <div style={{ clipPath: 'polygon(0 0, 100% 0, 95% 100%, 0% 100%)', width: 180, padding: '3px 6px', display: 'inline-block' }} className="bg-white">
                                                                        <h4 style={{ fontSize: '15px', lineHeight: '1.2', display: 'inline-block' }} className={classNames("font-bold", {
                                                                            "text-primary": product.stock > 0 && store === 'cerogrado',
                                                                            "text-black": product.stock > 0 && store === 'trampolinepark',
                                                                            "text-gray-400": product.stock <= 0
                                                                        })}>
                                                                            {product.name}
                                                                        </h4>
                                                                    </div>
                                                                    <div className="flex justify-center items-center sm:block mx-auto sm:mx-0">
                                                                        <h4 className="text-center text-white font-bold">
                                                                            {product.stock > 0 ? `$${numberFormat(product.price, 0, '', '.')}` : 'Sin stock'}
                                                                        </h4>
                                                                    </div>
                                                                </div>
                                                                <div className={classNames("grid grid-cols-3 w-full sm:w-24 border-t sm:border-0", {
                                                                    "border-primary": product.stock > 0 && store === 'cerogrado',
                                                                    "border-tp-primary": product.stock > 0 && store === 'trampolinepark',
                                                                    "border-gray-400": product.stock <= 0
                                                                })}>
                                                                    <MinusButton />
                                                                    <div style={{ padding: '3px' }} className="inline-flex justify-center items-center bg-white">
                                                                        <h4 className="text-center font-bold">
                                                                            {detail.quantity}
                                                                        </h4>
                                                                    </div>
                                                                    <PlusButton />
                                                                </div>
                                                            </div>
                                                            <div className="flex flex-col gap-2">
                                                                {detail.errors?.map(({ message, status }, index) => (
                                                                    <div className="m-0 p-0 text-sm text-center" style={{ color: 'red' }} key={`product-${product.id}-error-${status}-${index}`}>
                                                                        {message}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                        </div>
                                )}
                            </div>

                            <div className="block mt-6">
                                <label className="flex items-center mb-1">
                                    <Checkbox name="terms" value={data.terms} handleChange={onHandleChange} required={true} />
                                    <span className="ml-2 text-sm text-gray-600">
                                        Acepto y he leído el <a href={terms} target='_blank' className='underline'>Reglamento interno</a>.
                                    </span>
                                </label>
                                <label className="flex items-center mb-1">
                                    <Checkbox name="consent" value={data.consent} handleChange={onHandleChange} required={true} />
                                    <span className="ml-2 text-sm text-gray-600">
                                        Acepto y he leído el <a href={consent} target='_blank' className='underline'>Acuerdo de uso de las instalaciones</a>.
                                    </span>
                                </label>
                                <Error bind={errors.terms || axiosErrors?.terms} />
                            </div>

                        </div>

                        {/* {scheduleType.type !== 'skating_class' && usersRegistration && usersRegistration.length > 0 && (
                            <Clients clientDoesntHaveRutMessage="Asume el cliente" clients={usersRegistration} />
                        )} */}

                        <OrderStatus
                            isBulkOrder={Boolean(uuid)}
                            office={office}
                            date={date}
                            discountPercent={data.coupon_percent}
                            time={time}
                            scheduleType={scheduleType}
                            quantity={quantity}
                            price={price}
                            productsDetails={productsDetails}
                            couponDiscountTotalWithProducts={props.COUPON_DISCOUNT_TOTAL_WITH_PRODUCTS}
                        />

                        {/* {showJSONData(data)} */}

                        {!uuid && (
                            <CouponForm
                                data={data}
                                office={office}
                                onChange={(code) => setData('coupon_code', code)}
                                onCoupon={(coupon, data) => {
                                    if (coupon) {
                                        setData({
                                            ...data,
                                            coupon_id: coupon.id,
                                            coupon_percent: coupon.percent
                                        });
                                    } else {
                                        setData({
                                            ...data,
                                            coupon_id: null,
                                            coupon_percent: null
                                        });
                                    }

                                }}
                            />
                        )}


                        <div className="flex items-center justify-center mt-8 space-x-3">
                            <Link
                                href={parseInt(quantity) >= 2 ? route("schedule.users-registration", {office, scheduleType, schedule: schedule.id, uuid}) : route("schedule.search", {office: office.slug, scheduleType, uuid})}
                                as="button"
                                type="button"
                                className='flex items-center px-4 py-2 border border-gray-900 rounded-md font-semibold text-xs text-gray-900 hover:bg-gray-900 hover:text-white transition ease-in-out duration-150'
                                data={{ quantity, date: rawDate, schedule, uuid }}>
                                Modificar
                            </Link>
                            <Button style={{ width: '12ch', display: 'flex', justifyContent: 'center', alignItems: 'center' }} type="submit" processing={isProcessingButtonPayment}>
                                {isProcessingButtonPayment ? (
                                    <div role="status">
                                        <svg style={{ fill: 'rgba(17, 24, 39, 1)' }} aria-hidden="true" className="inline w-4 h-4 text-gray-200 animate-spin" viewBox="0 0 100 101" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                                            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                                        </svg>
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                ) : (uuid ? 'Cobrar' : 'Pagar')}
                            </Button>
                        </div>

                    </form>
                    {preference?.id && <Checkout publicKey={MPPublicKey} onCheckout={(element) => element.click()} preference={preference} />}
                    {/* {preference?.id && <Checkout publicKey={MPPublicKey} onCheckout={(element) => element.querySelector('.mercadopago-button').click()} preference={preference} />} */}

                </div>
            </div>
        </>
    );
}
